import { useEffect, useState } from "react"
import TabIcon from "../atoms/TabIcon";

const TabButton = ({index, handleChange, children, active, title='', icon=''}) => {
    const [checked, setChecked] = useState(false);
    const [activeClass, setActiveClass] = useState('');
    
    useEffect(() => {
        if ( active ) {
            setChecked(true);
            setActiveClass('active');
        } else {
            setActiveClass('');
        }
    }, [active]);
    

    const handleClick = (e) => {
        setChecked(!checked);

        if ( handleChange ) {
            handleChange(index);
        }
    }

    const renderContent = () => {
        if ( icon ) {            
            return ( <TabIcon className="icon" name={icon}/> );
        } else {
            if ( children ) {
                return ( <label> {children} </label> )
            }
        }
        return '';
    }

    return (
        <div className={ `tabbutton ${activeClass}`}>
            <button 
                className={ `btn btn--icon btn--tab tab-btn ${activeClass}` }
                onClick={handleClick}
             >
                { renderContent() }
            </button>
        </div>
    )
}

export default TabButton;